/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.create.availability.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
  'acme.view.application.entities.create.availability.typesModal.controllers'
])

.controller('EntitiesCreateAvailabilityController', ['$scope', '$state', '$uibModal', 'ApiService', 'HelpersService', 'CalendarService', 'PermissionsService', function($scope, $state, $uibModal, ApiService, HelpersService, CalendarService, PermissionsService) {

    $scope.entitiesCreateAvailability = {

      model: {
        resourceCategory: '',
        entityId: '',
        available: [],
        unavailable: []
      },

      dateRangeState: {
        available: [],
        unavailable: []
      },

      saveData: {},
      selectedAvailable: {},
      selectedUnavailable: {},
      selectedAvailableResourceTypes: [],

      availabilityOptions: [
        {
          type: 'weekdays',
          label: 'Weekdays'
        },
        {
          type: 'weekends',
          label: 'Weekends'
        },
        {
          type: 'never',
          label: 'Specific date(s)'
        },
        {
          type: 'weekly',
          label: 'Custom...'
        }
      ],

      availabilityTypeSelectText: {
        buttonDefaultText: 'Available for all roles'
      },

      resourceTemplates: [],

      init: function() {
        this.getTemplates();
        $scope.$on('EntitiesCreateController::Complete', this.onEntitiesCreateControllerComplete);
      },

      getAvailability: function() {
        ApiService.resource.availability.detail({ entityId: $state.params.id }).then(this.success.getAvailability, this.error.getAvailability);
      },

      getTemplates: function() {
        ApiService.resource.templates($.extend({}, { resourceCategory: HelpersService.cap($state.params.type) }, HelpersService.getPaginator())).then(this.success.getTemplates, this.error.getTemplates);
      },

      isRepeatCycle: function(slot, type) {
        return (slot.repeatCycle === type);
      },

      createRepeatDays: function() {
        return {
          Su: false,
          M: false,
          Tu: false,
          W: false,
          Th: false,
          F: false,
          Sa: false
        };
      },

      createSlot: function() {
        var date = new Date(),
            start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 9, 0, 0, 0),
            end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 17, 0, 0, 0);

        return {
          allDay: false,
          weekdays: [],
          endDate: '',
          startDate: '',
          endDatePicker: end,
          startDatePicker: start,
          repeatDays: this.createRepeatDays(),
          resourceTemplates: [],
          startTime: {
            date: start,
            hour: '',
            minutes: ''
          },
          endTime: {
            date: end,
            hour: '',
            minutes: ''
          }
        };
      },

      toggleDateRangeState: function(index, availabilityType) {
        this.dateRangeState[availabilityType][index].showEndDate = !this.dateRangeState[availabilityType][index].showEndDate;
      },

      removeSlot: function(index, availabilityType) {
        this.model[availabilityType].splice(index, 1);
        this.dateRangeState[availabilityType].splice(index, 1);
      },

      addUnavailableSlot: function() {
        this.model.unavailable.push(this.createSlot());
        this.dateRangeState.unavailable.push({ showEndDate: false });
      },

      addAvailableSlot: function() {
        this.model.available.push(this.createSlot());
        this.dateRangeState.available.push({ showEndDate: false });
      },

      showSelectedTypes: function(slot) {

        var self = $scope.entitiesCreateAvailability;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/entities/create/modals/chooseAvailabilityTypes.tpl.html',
          controller: 'EntitiesCreateAvailabilityTypesModalController',
          resolve: {

            skillLabels: function() {
              return $scope.entitiesCreate.getSkillLabel();
            },

            resourceTypes: function() {
              return $scope.entitiesCreate.resourceTemplates;
            },

            selectedResourceTypes: function() {
              return slot.resourceTemplates;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function (selected) {

          slot.resourceTemplates = angular.copy(selected);

        }, function () {
          // Do nothing
        });

      },

      findResourceTemplate: function(id) {
        var i, ii,
            r = false;
        for (i = 0, ii = this.resourceTemplates.length; i < ii; i++) {
          if (this.resourceTemplates[i].id === id) {
            r = {
              index: i,
              resourceTemplate: this.resourceTemplates[i]
            };
            break;
          }
        }
        return r;
      },

      completeAvail: function(type) {

        var day,
            i, ii,
            startTime,
            endTime;

        for (i=0,ii=this.saveData[type].length;i<ii;i++) {
          this.saveData[type][i].weekdays = [];

          for (day in this.saveData[type][i].repeatDays) {
            if(this.saveData[type][i].repeatDays[day]) {
              this.saveData[type][i].weekdays.push(day);
            }
          }

          this.saveData[type][i].endDate = CalendarService.toISO8601(this.saveData[type][i].endDatePicker).split('T')[0];
          this.saveData[type][i].startDate = CalendarService.toISO8601(this.saveData[type][i].startDatePicker).split('T')[0];

          endTime = new Date(this.saveData[type][i].endTime.date);
          startTime = new Date(this.saveData[type][i].startTime.date);

          this.saveData[type][i].startTime.hour = parseInt(startTime.getHours(), 10);
          this.saveData[type][i].startTime.minutes = parseInt(startTime.getMinutes(), 10);

          this.saveData[type][i].endTime.hour = parseInt(endTime.getHours(), 10);
          this.saveData[type][i].endTime.minutes = parseInt(endTime.getMinutes(), 10);

          if (!this.dateRangeState[type][i].showEndDate) {
            this.saveData[type][i].endDate = this.saveData[type][i].startDate;
          }

          this.saveData[type][i].endTime.date = null;
          delete this.saveData[type][i].endTime.date;

          this.saveData[type][i].startTime.date = null;
          delete this.saveData[type][i].startTime.date;

          this.saveData[type][i].startDatePicker = null;
          delete this.saveData[type][i].startDatePicker;

          this.saveData[type][i].endDatePicker = null;
          delete this.saveData[type][i].endDatePicker;

          this.saveData[type][i].repeatDays = null;
          delete this.saveData[type][i].repeatDays;

        }

      },

      complete: function() {
        this.saveData = angular.copy(this.model);
        this.saveData.entityId = $state.params.id;
        this.saveData.resourceCategory = HelpersService.cap($scope.entitiesCreate.entity.plural);
        this.completeAvail('available');
        this.completeAvail('unavailable');
        if (this.saveData.id) {
          ApiService.resource.availability.update(this.saveData).then(this.success.complete, this.error.complete);
        }else{
          ApiService.resource.availability.create(this.saveData).then(this.success.complete, this.error.complete);
        }
      },

      processAvail: function(type) {
        var i, ii,
            j, jj,
            endDate,
            startDate,
            endTime,
            startTime,
            d = new Date(),
            item,
            processResourceTemplate,
            resourceTemplates;

        processResourceTemplate = function(resourceTemplateId) {
          var self = $scope.entitiesCreateAvailability,
              found = self.findResourceTemplate(resourceTemplateId);

          if (found) {
            resourceTemplates.push(self.resourceTemplates[found.index]);
          }
        };

        for (i=0,ii=this.model[type].length;i<ii;i++) {

          // Reset templates between items
          resourceTemplates = [];

          item = this.model[type][i];
          item.repeatDays = this.createRepeatDays();

          for (j=0,jj=item.weekdays.length;j<jj;j++) {
            if (item.repeatDays.hasOwnProperty(item.weekdays[j])) {
              item.repeatDays[item.weekdays[j]] = true;
            }
          }

          endDate = item.endDate.split('-');
          startDate = item.startDate.split('-');

          item.endDatePicker =  new Date(parseInt(endDate[0], 10), parseInt(endDate[1], 10) - 1, parseInt(endDate[2], 10), 12, 0, 0, 0);
          item.startDatePicker = new Date(parseInt(startDate[0], 10), parseInt(startDate[1], 10) - 1, parseInt(startDate[2], 10), 12, 0, 0, 0);

          endTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), item.endTime.hour, item.endTime.minutes, 0, 0);
          startTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), item.startTime.hour, item.startTime.minutes, 0, 0);

          item.endTime.date = endTime;
          item.startTime.date = startTime;

          if (item.endDate === item.startDate) {
            this.dateRangeState[type].push({ showEndDate: false });
          }else{
            this.dateRangeState[type].push({ showEndDate: true });
          }

          if (item.resourceTemplateIds instanceof Array) {
            item.resourceTemplateIds.forEach(processResourceTemplate);
            item.resourceTemplates = angular.copy(resourceTemplates);
          }

        }

      },

      marshall: function(type) {
        var i, ii,
            item,
            resourceTemplateIds,
            resourceTemplates,
            processResourceTemplate = function(resourceTemplate) {
              if (resourceTemplate.id) {
                resourceTemplateIds.push(resourceTemplate.id);
              }
            };

        if (this.model.hasOwnProperty(type)) {
          for (i = 0, ii = this.model[type].length; i < ii; i++) {
            // Reset templates between items
            resourceTemplates = [];
            resourceTemplateIds = [];

            item = this.model[type][i];

            if (item.resourceTemplates instanceof Array) {
              item.resourceTemplates.forEach(processResourceTemplate);
              item.resourceTemplateIds = angular.copy(resourceTemplateIds);
              delete (item.resourceTemplates);
            }
          }
        }
      },

      process: function() {

        if (this.model.hasOwnProperty('available')) {
          this.processAvail('available');
        }

        if (this.model.hasOwnProperty('unavailable')) {
          this.processAvail('unavailable');
        }

      },

      success: {
        complete: function(response) {
          var self = $scope.entitiesCreateAvailability;

          self.model.id = response.data.payload.id;
        },
        /**
         *
         * {
         *   available: [{
         *     repeatCycle: 'weekdays',
         *     allDay: true,
         *     weekdays: ['M','Tu', 'W', 'Th', 'F', 'Sa', 'Su'],
         *     startTime: {
         *       hour: '',
         *       minutes: ''
         *     },
         *     endTime: {
         *       hour: '',
         *       minutes: ''
         *     }
         *   }],
         *   unavailable: [{
         *     repeatCycle: 'date',
         *     allDay: false,
         *     startDate: '2016-03-01',
         *     endDate: '2016-03-02',
         *     startTime: {
         *       hour: '',
         *       minutes: ''
         *     },
         *     endTime: {
         *       hour: '',
         *       minutes: ''
         *     }
         *   }]
         * }
         *
         * @param response
         */
        getAvailability: function(response) {
          var self = $scope.entitiesCreateAvailability;

          if (response.data.payload) {
            self.model = response.data.payload;
            self.process();
          }
        },

        getTemplates: function(response) {
          var self = $scope.entitiesCreateAvailability;

          self.resourceTemplates = response.data.payload.list;
          self.getAvailability();
        }
      },
      error: {
        complete: function(response) {},
        getAvailability: function(response) {
          var self = $scope.entitiesCreateAvailability;

          if (response.status === 404) {
            self.addAvailableSlot();
            self.addUnavailableSlot();
          }
        },
        getTemplates: function(response) {
          $scope.entitiesCreateAvailability.getAvailability();
        }
      },

      onEntitiesCreateControllerComplete: function() {
        var self = $scope.entitiesCreateAvailability;
        self.marshall('available');
        self.marshall('unavailable');
        self.complete();
      }

    };

    $scope.entitiesCreateAvailability.init();

}])
.controller('EntitiesCreateAvailabilityDatePickerController', ['$scope', '$timeout', 'HelpersService', 'UserPreferencesService', function($scope, $timeout, HelpersService, UserPreferencesService) {

  $scope.entitiesCreateAvailabilityDatePicker = {

    isOpen: false,
    
    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false
    },
    
    isPreferenceLoaded: false,
    
    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
    
    init: function() {
      this.today();
      $scope.initDate = new Date('2016-15-20');
      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'yyyyMMdd', 'shortDate'];
      $scope.format = $scope.formats[1];
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
          $scope.entitiesCreateAvailabilityDatePicker.isPreferenceLoaded = true;
      },0);
    },
    
    today: function() {
      this.dt = new Date();
    },
    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    },
    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.isOpen = true;
    },
    
    onDateFormatLoad: function (e, data) {
      var self = $scope.entitiesCreateAvailabilityDatePicker;
      self.dateFormat  = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }

  };
  
  $scope.entitiesCreateAvailabilityDatePicker.init();

}]);